/**
 * Initialize Swiper on a brand logos root element.
 *
 * @param {HTMLElement} rootEl `.brand-swiper.swiper` element.
 * @return {import('swiper').Swiper|null}
 */
export function initBrandSwiper( rootEl ) {
	if ( ! rootEl || typeof window.Swiper === 'undefined' ) {
		return null;
	}

	if ( rootEl.swiper && ! rootEl.swiper.destroyed ) {
		return rootEl.swiper;
	}

	const delay = parseInt( rootEl.dataset.autoplayDelay || '2000', 10 );

	return new window.Swiper( rootEl, {
		loop: true,
		speed: 900,
		slidesPerView: 6,
		spaceBetween: 30,
		autoplay: {
			delay: Number.isFinite( delay ) ? delay : 2000,
			disableOnInteraction: false,
		},
		breakpoints: {
			320: { slidesPerView: 2, spaceBetween: 15 },
			480: { slidesPerView: 3, spaceBetween: 20 },
			768: { slidesPerView: 4, spaceBetween: 25 },
			1024: { slidesPerView: 5, spaceBetween: 30 },
			1280: { slidesPerView: 6, spaceBetween: 30 },
		},
	} );
}

/**
 * Initialize every brand logos swiper on the page.
 */
export function initAllBrandSwipers() {
	document
		.querySelectorAll( '.brand-swiper.swiper' )
		.forEach( ( el ) => initBrandSwiper( el ) );
}
